import { RpcExtensionBrokerRequest } from './rpc-extension-broker-model';

/**
 * Rpc extension request sever side handler interface.
 */
export interface RpcExtensionBrokerRequestHandler {
    handler(data: RpcExtensionBrokerRequest): Promise<void>;
}
